<template>
  <v-dialog v-model="config.status.active" max-width="600px">
    <v-card class="dialog">
      <v-card-title class="primary amber blue-grey--text text--darken-4">
        <span class="headline">留学タイプの変更</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="form" v-model="form.valid" lazy-validation>
            <v-row dense>
              <v-col cols="12">
                <v-select required
                  v-model="form.type"
                  label="留学タイプ"
                  item-text="text"
                  item-value="value"
                  :items="getTypeItems"
                  :rules="rules.type"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn text color="secondary" @click="close">閉じる</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed color="secondary" @click="submit" :loading="isLoading">保存する</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'authorProgsModalsType',
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false
        }
      },
      form: {
        valid: true,
        id: '',
        type: ''
      },
      rules: {
        type: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    submit: function () {
      if (this.$refs.form.validate()) {
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(this.$url.api + 'progs/update/item', {
            id: this.form.id,
            type: this.form.type
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.$emit('done', res.data.data)
              this.close()
            }
            this.$set(this.config.status, 'loading', false)
          }).catch(err => {
            console.log(err)
            this.$set(this.config.status, 'loading', false)
          })
        })
      }
    },
    open: function (val) {
      const { id, type } = val
      this.$set(this.config.status, 'active', true)
      this.$set(this, 'form', {
        valid: true,
        id: id,
        type: type
      })
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    }
  },
  computed: {
    isActive () {
      return this.config.status.active
    },
    isLoading () {
      return this.config.status.loading
    },
    getTypeItems () {
      return Object.keys(this.$mango.arrange.types).map(key => {
        return {
          text: this.$mango.arrange.types[key],
          value: key
        }
      })
    }
  }
}
</script>
